import React from "react"
import MultiChannelCommunicationGraphic from "../../../../images/icons/proFeatures/multChannelCommunicationGraphic.svg"
import IntelligentDeliveryGraphic from "../../../../images/icons/proFeatures/intelligentDeliveryGraphic.svg"
import LightningFastMobilePageGraphic from "../../../../images/icons/proFeatures/lightningFastMobilePagesGraphic.svg"
import AppointmentBookingGraphic from "../../../../images/icons/proFeatures/appointmentBookingGraphic.svg"
import SegmentationAndTargetingGraphic from "../../../../images/icons/proFeatures/segmentationAndTargetingGraphic.svg"
import VideoMarketingGraphic from "../../../../images/icons/proFeatures/videoMarketingGraphic.svg"
import AdvancedAutomationGraphic from "../../../../images/icons/proFeatures/advancedAutomationGraphic.svg"
import CustomDomainsGraphic from "../../../../images/icons/proFeatures/customDomainsGraphic.svg"
import PaymentBillingGraphic from "../../../../images/platform/payments-billing/header-icons/pricing_icon.svg"
import H4 from "../../../../components/typography/H4"

const proFeaturesData = [
  {
    icon: MultiChannelCommunicationGraphic,
    title: (
      <H4>
        Multi-Channel
        <br /> Communication
      </H4>
    ),
    description:
      "Multiple channels means you can reach more leads and customers the way they want for better engagement.",
    comingSoon: false,
    url: "/platform/campaigns",
  },
  {
    icon: IntelligentDeliveryGraphic,
    title: (
      <H4>
        Intelligent <br />
        Delivery
      </H4>
    ),
    description:
      "Smart Reminders, Smart Send, Text Replacement, and advanced Campaign scheduling drive results.",
    comingSoon: false,
    url: "/features/intelligent-delivery",
  },
  {
    icon: LightningFastMobilePageGraphic,
    title: (
      <H4>
        “Lighting” Fast <br />
        Mobile Pages
      </H4>
    ),
    description:
      "Our next generation technology ensures fast landing page load times for higher response rates and better SEO.",
    comingSoon: false,
    url: "/platform/mobile-landing-pages",
  },
  {
    icon: AppointmentBookingGraphic,
    title: (
      <H4>
        Appointment
        <br />
        Booking
      </H4>
    ),
    description:
      "Connect your calendar, automatically book online appointments and capture new leads with ease.",
    comingSoon: false,
  },
  {
    icon: SegmentationAndTargetingGraphic,
    title: (
      <H4>
        Segmentation &<br /> Targeting
      </H4>
    ),
    description:
      "Organize Contacts by List, Interest, Tag, Type, Offer Redemption, Open, Click, Play or Response.",
    comingSoon: false,
    url: "/platform/contact-management",
  },
  {
    icon: PaymentBillingGraphic,
    title: (
      <H4>
        Payments
        <br />& Billing
      </H4>
    ),
    description:
      "Sell a Product, Service or membership.  Capture Donations with ease.  Manage Payments, Invoices & Subscriptions.",
    comingSoon: false,
    isBeta: true,
    url: "/platform/payments-billing",
  },
  {
    icon: AdvancedAutomationGraphic,
    title: (
      <H4>
        Advanced
        <br />
        Automation
      </H4>
    ),
    description:
      "Create powerful workflows, deliver communication and trigger actions over time with Automation Sequences.",
    comingSoon: false,
    url: "/platform/automation",
  },
  {
    icon: CustomDomainsGraphic,
    title: (
      <H4>
        Custom
        <br />
        Domains
      </H4>
    ),
    description:
      "Add unlimited domains to your mobile pages and deliver a custom, branded experience.",
    comingSoon: false,
    url: "/features/custom-domains",
  },
]

export default proFeaturesData
